<template>
	<div class="list">
		<div class="list-title">
			<div class="title" v-if="title">
			   <div class="title-content">{{title}}</div>
               <slot name="title-right"></slot>
			</div>
            <slot name="table-left"></slot>
            <slot name="add"></slot>
		</div>
        <div>
		    <slot name="filter-tab"></slot>
        </div>
		<slot name="spin"></slot>
		<div class="list-table">
			<div class="xc-list" :style="scroll?'overflow-x: scroll':''">
				<slot name="table"></slot>
			</div>
            <slot name="statistics-amount"></slot>
			<div class="list-bottom-bar" v-if="isShowBottomBar">
				<div class="list-bottom-box">
					 <!-- <Checkbox class="list-bottom-checkbox" :value="1">全选</Checkbox> -->
                    <div class="list-bottom-left" v-if="isExport || isCheckAll">
                        <Checkbox 
                            slot="list-bottom-left"
                            class="list-bottom-checkbox"
                            :value="checkAll" 
                            @click.prevent.native="selectCheckAll">全选</Checkbox>
                    </div>
                    <div class="operation-button-box">
                        <div class="list-bottom-btn-box" v-if="isExport && listData.length>0">
                            <Button class="list-bottom-btn" @click.native="handleExport">导出选中</Button> 
                            <Button class="list-bottom-btn" @click.native="handleExportSearch">导出检索结果</Button> 
                        </div>
                        <div class="list-bottom-left-box">
                            <slot name="bottom-left"></slot>
                        </div>
                        <div class="more" v-if="(isExport && listData.length>0) || isSlot">
                            <Dropdown trigger="click">
                                <a href="javascript:void(0)">
                                    <Button class="list-bottom-btn">
                                        更多
                                       <Icon type="ios-arrow-down"></Icon>
                                    </Button> 
                                </a>
                                <DropdownMenu slot="list" > 
                                    <Button class="list-bottom-btn" @click.native="handleExportSearch" v-if="isExport && listData.length>0">导出检索结果</Button> 
                                        <slot name="bottom-left"></slot>
                                </DropdownMenu>
                            </Dropdown>
                        </div>
                        
                    </div>
                    <div class="list-bottom-right">
                        <slot name='bottom-right'></slot>
                        <Page 
                            v-if="page"
                            @on-change="handleChange"
                            @on-page-size-change="handlePageSizeChange"
                            :page-size-opts="[15,30,50,100]"
                            :current="searchData.page"
                            :page-size="searchData.limit"
                            :total="total"
                            
                            show-sizer
                            show-total>
                        </Page>
                    </div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>

export default {
    data(){
        return {
            slotStatus:false
        }
        
    },
    props: {
        title: {
            type: String,
            default: ""
        },
        total:{
            type:Number,
            default:0
        },
        listData:{
            type:Array,
            default:()=>{return []}
        },
        indeterminate:{
            type:Boolean,
            default:false
        },
        checkAll:{
            type:false,
            default:false
        },
        newCheckAll:{
            type:Array,
            default:()=>{return []}
        },
        // selectCheckAll:{
        //     type:Function,
        //     default:()=>{}
        // },
        searchData:{
            type:Object,
            default:()=>{return {
				page:1,
            	limit:15
			}}
        },
        page:{
            type:Boolean,
            default:true
		},
		scroll:{
			type:Boolean,
			default:false
        },
        isShowBottomBar:{
            type:Boolean,
            default:true
        },
        /**
         * 是否需要导出
         */
        isExport:{
            type:Boolean,
            default:false
        },
        /**
         * 是否显示插槽内容
         */
        isSlot:{
            type:Boolean,
            default:false
        },
        /**
         * 是否需要复选框
         */
        isCheckAll:{
            type:Boolean,
            default:false
        }
    },
    methods:{
        /**
         * 页码改变的事件派发
         * 
         * @param {Number} page 页码
         */
        handleChange(page){
            this.$emit('select-change',page);
        },
        /**
         * 切换每页条数时的事件派发
         * 
         * @param {Number} pageSize 每页条数
         */
        handlePageSizeChange(pageSize){
            this.$emit('select-page-size-change',pageSize);
        },
        selectCheckAll(){
            this.$emit('select-checkall')
        },
        /**
         * 导出选中事件派发
         */
        handleExport(){
            this.$emit('select-export')
        },
        /**
         * 导出检索结果事件派发
         */
        handleExportSearch(){
            this.$emit('select-export-search')
        }
        
    },
};
</script>
<style scoped lang="less">

.list {
	position: relative;
	margin-top: 16px;
	background: rgba(255, 255, 255, 1);
	box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.06);

	.list-title {
		width: 100%;
		line-height: 48px;
		font-size: 14px;
		font-weight: bold;
		color: rgba(70, 76, 91, 1);
		/* border-bottom: 1px solid rgba(227, 232, 238, 1); */
        // display: flex;
        // justify-content: space-between;
        padding-left: 24px;
        clear: both;
        // min-height: 73px;
        overflow: hidden;
        .title{
            
            .title-content{
                float: left;
            }
            
        }
		.table-left{
            float: left;
            margin-bottom: 7px;
            clear: both;
		}
		.add{ 
			float:right; 
			margin-right: 24px;
			margin-top: -1px;
			cursor: pointer;
        }
        
	}
	.list-table{
        width: 100%;
        display: inline-block;
		.list-bottom-bar{
			padding: 24px;
			overflow: hidden;

            .list-bottom-box{
                .list-bottom-left{
                    float: left;
                    height: 32px;
                    line-height: 32px;
                    .list-bottom-checkbox{
                        float: left;
                    }
                    
                }
                .operation-button-box{
                    display: inline-block;
                    vertical-align: middle;
                    font-size: 0;
                    margin-left: 8px;
                }
            }
            .list-bottom-left-box{
                display: inline-block;
                font-size: 0;
                vertical-align: middle;
                margin-left: 8px;
            }
            .list-bottom-btn-box{
                // float: left;
                display: inline-block;
                vertical-align: middle;
                font-size: 0;

                .list-bottom-btn{
                    // float: left;
                    margin-left: 8px;
                    vertical-align: top;
                    &:first-child{
                        // margin-left: 16px;
                    }
                }
                
            }
			.list-bottom-right{
				float: right;
			}
		}
	}
}



</style>
